import styled from "styled-components";

export const FiltersWrapper = styled.div`
  .input-search {
    padding: 10px;
    border: none;
    border-radius: 40px;
    background: #f7f7f7;
    outline: none;
  }

  .select-form {
    border: 1px solid #ebeaef;
    outline: none;
    padding: 5px;
    width: 150px;
    margin-left: 10px;
    border-radius: 40px;
  }
  margin-top: 145px;
`;
